// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__Aoolr","range":"MonthRangeSwitch_range__2vwqI","disabled":"MonthRangeSwitch_disabled__1Pmxq"};